// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".range-date-picker-input[data-v-5a45d8a8]{width:130px;cursor:default}.range-date-picker-input[data-v-5a45d8a8] .v-input__slot,.range-date-picker-input[data-v-5a45d8a8] .v-text-field__slot,.range-date-picker-input[data-v-5a45d8a8] input,.range-date-picker-input[data-v-5a45d8a8] label{cursor:default!important}.range-date-picker-input[data-v-5a45d8a8] input{pointer-events:none}", ""]);
// Exports
module.exports = exports;
